import Aura from '@primeng/themes/aura';
import { definePreset } from '@primeuix/themes';

export const NoirPreset = definePreset(Aura, {
	// Font
	typography: {
		fontFamily:
			"Montserrat, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', 'Liberation Sans', sans-serif"
	},

	semantic: {
		// ===== PRIMARY (scala di grigi da bianco a nero) =====
		primary: {
			50: '#f9fafb',
			100: '#f2f2f2',
			200: '#e6e6e6',
			300: '#d0d0d0',
			400: '#a3a3a3',
			500: '#737373',
			600: '#525252',
			700: '#404040',
			800: '#262626',
			900: '#171717',
			950: '#0a0a0a'
		},

		// ===== COLOR SCHEME =====
		colorScheme: {
			light: {
				// ----- PRIMARY -----
				primary: {
					color: '#000000',
					contrastColor: '#ffffff',
					hoverColor: '#262626',
					activeColor: '#404040'
				},

				// ----- HIGHLIGHT -----
				highlight: {
					background: '#000000',
					focusBackground: '#262626',
					color: '#ffffff',
					focusColor: '#ffffff'
				},

				// ----- SURFACE -----
				surface: {
					0: '#ffffff',
					50: '#f9fafb',
					100: '#f2f2f2',
					200: '#e6e6e6',
					300: '#d0d0d0',
					400: '#a3a3a3',
					500: '#737373',
					600: '#525252',
					700: '#404040',
					800: '#262626',
					900: '#171717',
					950: '#0a0a0a'
				},

				// ----- MASK -----
				mask: {
					background: 'rgba(0, 0, 0, 0.4)',
					color: '#ffffff'
				},

				// ----- FORM FIELD -----
				formField: {
					background: '#ffffff',
					disabledBackground: '#f2f2f2',
					filledBackground: '#f9fafb',
					filledHoverBackground: '#f2f2f2',
					filledFocusBackground: '#ffffff',
					borderColor: '#d0d0d0',
					hoverBorderColor: '#a3a3a3',
					focusBorderColor: '#000000',
					invalidBorderColor: '#DB504A',
					color: '#171717',
					disabledColor: '#737373',
					placeholderColor: '#a3a3a3',
					invalidPlaceholderColor: '#DB504A',
					floatLabelColor: '#737373',
					floatLabelFocusColor: '#000000',
					floatLabelActiveColor: '#000000',
					floatLabelInvalidColor: '#DB504A',
					iconColor: '#737373',
					shadow: '0 0 0 0 rgba(0, 0, 0, 0)'
				},

				// ----- TEXT -----
				text: {
					color: '#171717',
					hoverColor: '#000000',
					mutedColor: '#737373',
					hoverMutedColor: '#525252'
				},

				// ----- CONTENT -----
				content: {
					background: '#ffffff',
					hoverBackground: '#f9fafb',
					borderColor: '#e6e6e6',
					color: '#171717',
					hoverColor: '#000000'
				},

				// ----- OVERLAY -----
				overlay: {
					select: {
						background: '#ffffff',
						borderColor: '#e6e6e6',
						color: '#171717'
					},
					popover: {
						background: '#ffffff',
						borderColor: '#e6e6e6',
						color: '#171717'
					},
					modal: {
						background: '#ffffff',
						borderColor: '#e6e6e6',
						color: '#171717'
					}
				},

				// ----- LIST -----
				list: {
					option: {
						focusBackground: '#f2f2f2',
						selectedBackground: '#e6e6e6',
						selectedFocusBackground: '#d0d0d0',
						color: '#171717',
						focusColor: '#000000',
						selectedColor: '#000000',
						selectedFocusColor: '#000000',
						icon: {
							color: '#737373',
							focusColor: '#525252'
						}
					},
					optionGroup: {
						background: '#f9fafb',
						color: '#525252'
					}
				},

				// ----- NAVIGATION (per menubar) -----
				navigation: {
					item: {
						focusBackground: 'rgba(255, 255, 255, 0.1)',
						activeBackground: 'rgba(255, 255, 255, 0.2)',
						color: '#ffffff',
						focusColor: '#ffffff',
						activeColor: '#ffffff',
						icon: {
							color: '#ffffff',
							focusColor: '#ffffff',
							activeColor: '#ffffff'
						}
					},
					submenuLabel: {
						background: 'transparent',
						color: '#ffffff'
					},
					submenuIcon: {
						color: '#ffffff',
						focusColor: '#ffffff',
						activeColor: '#ffffff'
					}
				}
			}
		}
	}
});
